import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { PaymentDeiails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment-overview.component.html',
  styleUrls: ['./payment-overview.component.css']
})
export class PaymentOverviewComponent implements OnInit {

  @Input() nextClicked = new EventEmitter<boolean>();

  patientpersonalinfo: any;
  isCopay: any = false;
  isoutstanding: any = false;
  amount: any = '';
  amountDueTemp: number;
  paymentType: any;
  selectedBox: string = "";
  ShowAmountField: boolean = true;
  paymentForm: FormGroup = new FormGroup({});
  isMinAmount: boolean = true;
  payLaterButton: any = true;
  storedIsWithin24Hours: any;
  appointmentId: any;
  constructor(private translateService: TranslateService, private _location: Location, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private service: PaymentService, private _router: Router, private location: Location) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this._router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.patientpersonalinfo = this.phrUtils.decrypt(localStorage.getItem('PatientInfo'));
  }
  AppointmentStatusId: any;
  ngOnInit(): void {
    const appstId = localStorage.getItem("apptstId");
    if (appstId == null || appstId == undefined || appstId == '') {
      this.AppointmentStatusId = '';
    } else {
      this.AppointmentStatusId = appstId;
      // console.log("inside appointment id  ", apptid);
    }
    this.storedIsWithin24Hours = localStorage.getItem('isWithin24Hours');
    const apptid = localStorage.getItem("apptId")
    // console.log("appointment id  ", apptid);
    if (apptid == null || apptid == undefined || apptid == '') {
      this.appointmentId = '';
    } else {
      this.appointmentId = apptid;
      // console.log("inside appointment id  ", apptid);
    }
    const isPayLaterEnabled = localStorage.getItem("isPayLaterEnabled");
    console.log("isPayLaterEnabled in payment  ", isPayLaterEnabled);

    if (isPayLaterEnabled == null || isPayLaterEnabled == undefined || isPayLaterEnabled == '') {
      this.payLaterButton = true;
    } else {
      if (isPayLaterEnabled == "0")
        this.payLaterButton = false;
      else
        this.payLaterButton = true;
      // console.log("inside appointment id  ", apptid);
    }
    localStorage.removeItem("pType");
    this.getPaymentDetails();
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.phrUtils.setTitle('Pagar el saldo adeudado');
      } else if (language === 'hi') {
        this.phrUtils.setTitle('बकाया राशि का भुगतान करें');
      } else if (language === 'ur') {
        this.phrUtils.setTitle('بقایا بیلنس ادا کریں');
      }
      else {
        this.phrUtils.setTitle('Pay Due Balance');
      }
    });
    this.buildpaymentForm();
  }
  buildpaymentForm() {
    this.paymentForm = new FormGroup({
      amount: new FormControl('', [Validators.required, Validators.max(4999)]),
    });
  }
  onClickBack() {
    //this._router.navigateByUrl("/securelogin");
    this.location.back();
  }

  //onClickNext(){
  //  if (Number(this.paymentDetials.data.totalAmount) <= 0) {
  //    let text = "No dues to pay.";
  //    this.translateService.get('Alerts.no_dues_to_pay').subscribe((translation: string) => {
  //      text = translation;
  //    });
  //    this.phrUtils.showWarning(text);
  //    //this.phrUtils.showWarning('No dues to pay.');
  //  }
  //  else{
  //    this._router.navigateByUrl("/payment");
  //  }
  //}
  get getpaymentForm() {
    return this.paymentForm.controls;
  }
  onClickNext() {
    const amount = this.getpaymentForm['amount'].value;
    if (this.isCopay == true && this.isoutstanding == false) {
      this.amount = this.paymentDetials.data.currentDayAmount;
      this.selectedBox = 'box2';
      localStorage.setItem("amt", this.amount);
      this.paymentType = "copay";
      localStorage.setItem("pType", this.paymentType);
      this._router.navigateByUrl("patient/payment");
    } else {
      if (this.isCopay == true && this.isoutstanding == true && this.selectedBox == '') {
        if (amount <= Number(this.paymentDetials.data.currentDayAmount)) {
          this.paymentType = "copay";
          localStorage.setItem("pType", this.paymentType);
        } else {
          this.paymentType = "dueandcopay";
          localStorage.setItem("pType", this.paymentType);
        }

      }
      if (Number(this.paymentDetials.data.totalAmount) <= 0) {
        let text = "No dues to pay.";
        this.translateService.get('Alerts.no_dues_to_pay').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showWarning(text);
        //this.phrUtils.showWarning('No dues to pay.');
      } else if (amount.length == 0) {
        let text = "Please select / enter Amount";
        this.translateService.get('Alerts.select_enter_amount').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showWarning(text);
      }
      else {
        this.paymentForm.markAllAsTouched();
        if (this.paymentForm.invalid) {
          return;
        }
        console.log("amount ", amount)
        console.log("amount due ", this.amountDueTemp)
        if (amount > this.amountDueTemp) {
          return;
        }
        if (!this.isMinAmount) {
          return;
        }
        if (this.isCopay == false && this.isoutstanding == true) {
          this.paymentType = "due";
          localStorage.setItem("pType", this.paymentType);
        }

        // this.phrUtils.updateAmount(this.amount);
        localStorage.setItem("amt", amount);
        this._router.navigateByUrl("/payment");
      }
    }

  }

  isMinuDueAmount: string = "false";
  isMinuTotalAmount: string = "false";
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  getPaymentDetails() {
    this.spinner.show();
    this.service.getPaymentDetailsOld(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account).subscribe((res: any) => {
      this.spinner.hide();
      //   { "statusCode": 200, "message": "SUCCESS","data": { "amT_DUE": "492.90", "currentDayAmount": "0.00",
      //         "totalAmount": "492.90",
      //         "prI_SEC_OTH_TYPE": "P", "id": "1", "inspayeR_DESCRIPTION": "MEDICARE ADVANTAGE", "visit_Date": "",
      //         "visit_Reasons": ""  } }
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        this.amountDueTemp = Number(this.paymentDetials.data.totalAmount);

        // execute incase of already check-in
        /*
        if (this.paymentDetials.data.totalAmount != null && this.paymentDetials.data.totalAmount != "") {
         if (this.AppointmentStatusId == "15") {
            this.hidebackButton = true;
           this.showMessage = true;
          }
        } */
        if (Number(this.paymentDetials.data.totalAmount) < 0 && this.paymentDetials.data.totalAmount.includes('-')) {
          this.isMinuTotalAmount = this.paymentDetials.data.totalAmount.replace('-', '');
          this.isMinuTotalAmount = Number(this.isMinuTotalAmount).toLocaleString();
        }
        if (Number(this.paymentDetials.data.amT_DUE) < 0 && this.paymentDetials.data.amT_DUE.includes('-')) {
          this.isMinuDueAmount = this.paymentDetials.data.amT_DUE.replace('-', '');
          this.isMinuDueAmount = Number(this.isMinuDueAmount).toFixed(2).toLocaleString();
        }
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.isCopay = true;
        } else {
          this.isCopay = false;
        }
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.isoutstanding = true;
        } else {
          this.isoutstanding = false;
        }
        if (this.isCopay == true && this.isoutstanding == false) {
          this.ShowAmountField = false;
        }
        /*
        if (this.isCopay == true && this.isoutstanding == false) {
          this.selectedBox = 'box2'
          this.amount = this.paymentDetials.data.currentDayAmount;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
        } else if (this.isCopay == false && this.isoutstanding == true) {
          this.selectedBox = 'box1';
          this.amount = this.paymentDetials.data.amT_DUE;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
        }*/
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }
  selectBox(boxId: string): void {
    // this.selectedBox = boxId;
    console.log(this.selectedBox);
    if (boxId == 'box1') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.amount = this.paymentDetials.data.amT_DUE;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
          this.selectedBox = boxId;
          console.log(this.amount);
          this.paymentType = "due";
          localStorage.setItem("pType", this.paymentType);
          this.isMinAmount = true;
        }
      }

    } else if (boxId == 'box2') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.amount = this.paymentDetials.data.currentDayAmount;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
          this.selectedBox = boxId;
          console.log(this.amount);
          this.paymentType = "copay";
          localStorage.setItem("pType", this.paymentType);
          this.isMinAmount = true;
        }
      }

    } else if (boxId == 'box3') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        this.amount = this.paymentDetials.data.totalAmount;
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
        console.log(this.amount);
        this.selectedBox = boxId;
        this.paymentType = "dueandcopay";
        localStorage.setItem("pType", this.paymentType);
        this.isMinAmount = true;
      }

    }
    console.log(this.amount);
  }
  payCopay() {
    this.phrUtils.updateAmount(this.paymentDetials.data.currentDayAmount);
    this._router.navigateByUrl("patient/payment");
  }

  payTotalBalance() {
    this.phrUtils.updateAmount(this.paymentDetials.data.totalAmount);
    this._router.navigateByUrl("patient/payment");
  }
  checkAmountInput(event: any) {
    const amt = event.target.value;
    console.log("amunt ", amt);
    console.log("select box ", this.selectedBox);
    if (this.selectedBox) {
      if (amt.length > 0) {
        this.selectedBox = '';
      }
    }
    if (amt < Number(this.paymentDetials.data.currentDayAmount)) {
      this.isMinAmount = false;
    } else {
      this.isMinAmount = true;
    }
  }
  validateCurreny(e: any): boolean {
    //this.checkAmountInput(e);
    let curr = e.target.value;

    let dotExists = curr.indexOf('.') > -1 ? true : false;
    if (e.keyCode > 47 && e.keyCode < 58) {
      if (dotExists && curr.length == (curr.indexOf('.') + 3)) {
        return false;
      }
      else if (dotExists && curr.length < (curr.indexOf('.') + 3)) {
        return true;
      }
      if (Number(curr + e.key) <= 9999.99) {
        return true;
      }
      return false;
    }
    else if (e.keyCode === 46) {
      if (dotExists) {
        return false;
      }
      return true;
    }
    // else if(!this.isNewPatient && Number(curr + e.key ) > Number(this.paymentDetials.data.amT_DUE)){
    //   return true;
    // }
    else {
      return false;
    }
  }
  onFinishIntake() {
    localStorage.setItem("noIntakeForm", "true");
    this._router.navigateByUrl('patient/thank-you');
  }
}
